<!-- <h1 mat-dialog-title *ngIf="!nonComcast">Successfully updated the power supply</h1> -->
<h1 mat-dialog-title *ngIf="!nonComcast">{{psUpdatedMsg}}</h1>
<!-- <h1 mat-dialog-title *ngIf="nonComcast">Successfully updated the power supply and it will be reviewed and accepted</h1> -->
<h1 mat-dialog-title *ngIf="nonComcast">Powersupply changes saved for triage. XOC Agents need to approve your changes before it takes effect</h1>
<mat-dialog-actions class="d-flex justify-content-center">
  <button mat-button type="button" (click)="onclickOK()">OK</button>
</mat-dialog-actions>